import React, {Component} from "react";
import {
    View,
    FlatList,
    ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity, Alert, BackHandler, Image
} from "react-native";
import EmptyView from "../../../customviews/empty/EmptyView";
import {AsyngStorageClass} from "../../../tools/AsyngStorageClass";
import Colors from "../../../tools/Colors";
import DialogConnectionCustomize from "../../../customviews/DialogConnectionCustomize";
import HMActionBar from "../../../customviews/HMActionBar";
import i18n from "../../../I18n/i18n";
import {typeExport} from "../../../redux/store/type";
import store from "../../../redux/store";
import {
    serviceActionAddSubList,
    serviceActionListFilter,
    serviceActionSuccess,
    serviceActionError
} from "./action/ActionListOperatorFireApplysScreen";
import {moderateScale} from "../../../tools/Scaling";
import HMTextView from "../../../customviews/HMTextView";
import DialogLoadingCustomize from "../../../customviews/DialogLoadingCustomize";

import * as  NavigationService from "../../../redux/NavigationService";
import AdapterListOperatorFireApply from "./adapter/AdapterListOperatorFireApply";
import {Tools} from "../../../tools/Tools";
import {serviceActionSetLocation} from "../../../screens/137/splash/action/ActionSplashGetAllData";
import axios from "axios";
import DeviceInfo from "../../../importCalss/DeviceInfo";
import HMIcon from "../../../customviews/HMIcon";
import HMButton from "../../../customviews/HMButton";
import HMMap from "../../../customviews/map/HMMap";


import importFirebase from "../../../importCalss/firebase/importFirebase";
import HMAlert from "../../../customviews/HMAlert";
// import HMBottomSheetSwipeablePanel from "../../../customviews/bottomSheet/HMBottomSheetSwipeablePanel";
/*import HMBottomSheet from "../../../customviews/bottomSheet/HMBottomSheet";*/

let firebase = importFirebase;


let container = null;
let MAC_ADDRESS = null
export default class ListOperatorFireApplyScreen extends Component {
    constructor(props) {
        super(props);

        let myLocation = store.getState().reducerSplashGetAllData.Location;
        let lat = 0
        let long = 0
        if (!myLocation) {
            lat = parseFloat(myLocation ? myLocation.coords.latitude : 0);
            long = parseFloat(myLocation ? myLocation.coords.longitude : 0);
            // long = parseFloat(props.navigation && props.route.params ? props.route.params.position.coords.longitude : props.position ? props.position.coords.longitude : 0);

        }
        const openPanel = () => {
            this.setState({isPanelActive: true});
        };

        const closePanel = () => {
            this.setState({isPanelActive: false});
        };

        this.state = {
            isPanelActive: true,
            panelProps: {
                fullWidth: true,
                openLarge: true,
                showCloseButton: true,
                onClose: () => closePanel(),
                onPressCloseButton: () => closePanel(),
                // ...or any prop you want
            },

            //  indexSelectParent:0,
            token: "359601088562055",
            checkPushResultOffline: false,
            textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: '',
            indexFilter: 0,

            lat: lat,
            long: long,
            dataSourcearrayCondition: [{name: 'ثبت شد', id: 1}, {
                name: 'در دست اقدام',
                id: 2
            }, {name: 'تکراری در دست اقدام', id: 3}, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {
                name: 'تایید واحد',
                id: 5
            },],
            textCondition: null,
            arrayCondition: [{name: 'ثبت شد', id: 1}, {name: 'در دست اقدام', id: 2}, {
                name: 'تکراری در دست اقدام',
                id: 3
            }, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {name: 'تایید واحد', id: 5},],
            Condition: {id: 0, value: "وضعیت پیام"},

            arrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            textOperational_Unit: null,
            dataSourcearrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            Operational_Unit: {id: 0, value: "واحد اجرایی"},

            arraySelected: [],
            trackingCode: null,
            Once: true,
            OnceSendBattery: true,
            OnceSendLocation: true,

        };
        container = this;


    }

    state = {
        show: false
    };

    componentWillReceiveProps(props) {


        props.results && props.results.length > 0 && this.state.Once ?
            this.setState({
                    Once: false
                },
                () => {

                    Tools.goDetailsOpenNotif()

                }
            )
            :
            null
    }

    checkBeforeSendLocation(coordinate, battery) {
        let myLocation = store.getState().reducerSplashGetAllData.Location;

        if (container.state.OnceSendBattery && (battery || battery == 0) && battery <= 15) {
            container.setState({
                    OnceSendBattery: false,
                    OnceSendLocation: false,

                },
                () => {

                    container.sendLocation(coordinate, battery)
                }
            )

        }
        else {
            if (!myLocation || (container.state.OnceSendLocation)) {

                container.setState({
                    OnceSendLocation: false
                })
                //   myLocation = position
                //store.dispatch(serviceActionSetLocation({coords: coordinate}))
                container.sendLocation(coordinate, battery)

            }
            else {
                let l = Tools.getDistance(coordinate, myLocation.coords)
                if (l > 20) {

                    container.sendLocation(coordinate, battery)
                }

                // this.setState({
                //     updateMyLocation:coordinate
                // })
            }
        }
    }


    async componentDidMount() {
        let checkGetData = true;

        this.props.navigation.addListener('focus', () => {
                if (global.RefreshListOperatorFireApplyScreen) {
                    checkGetData = false;
                    global.RefreshListOperatorFireApplyScreen = false;
                    store.dispatch(serviceActionListFilter([]))
                    this.props.callserviceActionRefresh();
                    this.getData(1)
                }
                /*   store.dispatch(serviceActionListFilter([]))
                   props.callserviceActionRefresh();
                   this.getData(1)*/
            }
        )
        this.props.navigation.addListener('blur', () => {
            }
        )

        if (checkGetData === true) {
            store.dispatch(serviceActionListFilter([]));
            this.props.callserviceActionRefresh();
            this.getData(1);
        }
        // console.log("this.map.mapRef.current.leafletElement", this.map.mapRef.current, this.map.mapRef.current.leafletElement);
        // map.locate().on("locationfound", function (e) {
        //     // setPosition(e.latlng);
        //     // map.flyTo(e.latlng, map.getZoom());
        //     // const radius = e.accuracy;
        //     // const circle = L.circle(e.latlng, radius);
        //     // circle.addTo(map);
        //  //   setBbox(e.bounds.toBBoxString().split(","));
        // });
        if (Platform.OS === "web" && navigator.geolocation) {
            navigator.geolocation.watchPosition(function (position) {

                // console.log("Latitude is :", position.coords.latitude);
                // console.log("Longitude is :", position.coords.longitude);
                let coordinate = position.coords;
                // container.setState({
                //     lllllllll: position.coords.latitude + " / " + position.coords.longitude
                // })
                var battery = null;
                var batteryNavigator = navigator.getBattery();

                if (batteryNavigator) {
                    batteryNavigator.then((batteryData) => {
                        battery = parseInt(batteryData.level * 100);

                        container.checkBeforeSendLocation(coordinate, battery)
                    });

                }
                else {
                    container.checkBeforeSendLocation(coordinate, battery)

                }


            });


        }

        if (Platform.OS !== "web") {
            await DeviceInfo.getMacAddress().then(mac => {
                //alert(mac)
                MAC_ADDRESS = mac
            });
            /*   const channel = new firebase.notifications.Android.Channel(
                   'channelId',
                   'Channel Name',
                   firebase.notifications.Android.Importance.Max
               ).setDescription('A natural description of the channel');
               firebase.notifications().android.createChannel(channel);

 //   the listener returns a function you can use to unsubscribe
    this.unsubscribeFromNotificationListener = firebase.notifications().onNotification((notification) => {
        //  alert("yyyy")
        if (Platform.OS === 'android') {
            const localNotification = new firebase.notifications.Notification({
                sound: 'default',
                show_in_foreground: true,
            }).setNotificationId(notification.notificationId)
                .setTitle(notification.title)
                .setSubtitle(notification.subtitle)
                .setBody(notification.body)
                .setData(notification.data)
                .android.setChannelId('channelId') // e.g. the id you chose above
                .android.setSmallIcon('logo') // create this icon in Android Studio
                .android.setColor('#000000') // you can set a color here
                .android.setPriority(firebase.notifications.Android.Priority.High);

            firebase.notifications()
                .displayNotification(localNotification)
                .catch(err => console.error(err));

        }
        else if (Platform.OS === 'ios') {

            const localNotification = new firebase.notifications.Notification()
                .setNotificationId(notification.notificationId)
                .setTitle(notification.title)
                .setSubtitle(notification.subtitle)
                .setBody(notification.body)
                .setData(notification.data)
                .ios.setBadge(notification.ios.badge);

            firebase.notifications()
                .displayNotification(localNotification)
                .catch(err => console.error(err));
        }


        if (notification && notification.data && notification.data.typeOperation == 2) {
            store.dispatch(serviceActionListFilter([]))
            this.props.callserviceActionRefresh();
            this.getData(1)
        }

    });


    this.notificationOpenedListener = await firebase.notifications().onNotificationOpened((notificationOpen: NotificationOpen) => {
        // Get the action triggered by the notification being opened
        const action = notificationOpen.action;
        // Get information about the notification that was opened
        const notification: Notification = notificationOpen.notification;
        let item = null
        if (notificationOpen.notification.data.item)
            item = JSON.parse(notificationOpen.notification.data.item.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())

        // console.log("NotificationOpen", notificationOpen.notification.data.item, item)
        try {
            firebase.notifications().removeDeliveredNotification(notificationOpen.notification._notificationId)

            switch (notificationOpen.notification.data.typeOperation) {
                //looking for
                case "2":
                    if (item) {
                        if (this.props.result && this.props.result > 0) {
                            let idx = this.props.result.CartList.findIndex(obj => obj.RequestID === item.RequestID)
                            if (idx === -1) {
                                store.dispatch(serviceActionListFilter([]))
                                this.props.callserviceActionRefresh();
                                this.getData(1)
                            }

                        }

                        NavigationService.navigateParams("DetailsOperatorFireApplyScreen", {
                            index: 0,
                            item: item,
                        })
                    }

                    // console.log("notificationOpen1", notificationOpen.notification.data.type)
                    // NavigationService.navigatereset("MessagesBuy", {type: 1});
                    //NavigationService.navigateParams("MessagesBuy", {type: 2});
                    break;

                // case "1":
                //     //  console.log("notificationOpen2", notificationOpen.notification.data.type)
                //     // NavigationService.navigatereset("MessagesSell", {type: 2});
                //     NavigationService.navigateParams("MessagesSell", {type: 1});
                //     break;
                default:
                // console.log("notificationOpen", notificationOpen.notification.data.type)

            }

        }
        catch (e) {

        }
        /!*   console.log("notificationOpen", notificationOpen)
           console.log("notificationOpen.action", notificationOpen.action)
           console.log("notificationOpen.notification", notificationOpen.notification)*!/

    });
*/

            // let myLocation = store.getState().reducerSplashGetAllData.Location;
            // myLocation ? this.sendLocation(myLocation.coords) : null;
        }
        this.unsubscribeFromNotificationListener = Tools.receiveonOnNotification(this.refreshData)


        this.notificationOpenedListener = Tools.receiveOnNotificationOpened()
    }

    refreshData() {
        store.dispatch(serviceActionListFilter([]))

        container.props.callserviceActionRefresh();
        container.getData(1)
    }

    /*    async goDetailsOpenNotif() {
            const notificationOpen = await firebase.notifications().getInitialNotification();
            //console.log("NotificationOpen2", notificationOpen)
            let item = null

            if (notificationOpen) {
                if (notificationOpen.notification.data.item)
                    item = JSON.parse(notificationOpen.notification.data.item.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())
                /!*   console.log("notificationOpen2", notificationOpen)
                   console.log("notificationOpen.action2", notificationOpen.action)
                   console.log("notificationOpen.notification2", notificationOpen.notification)*!/
                firebase.notifications().removeDeliveredNotification(notificationOpen.notification._notificationId)
                try {
                    switch (notificationOpen.notification.data.typeOperation) {
                        //looking for
                        case "2":
                            if (item)
                                NavigationService.navigateParams("DetailsOperatorFireApplyScreen", {
                                    index: 0,
                                    item: item,
                                })
                            // console.log("notificationOpen1", notificationOpen.notification.data.type)
                            // NavigationService.navigatereset("MessagesBuy", {type: 1});
                            //     NavigationService.navigateParams("MessagesBuy", {type: 2});
                            break;

                        case "1":
                            //  console.log("notificationOpen2", notificationOpen.notification.data.type)
                            // NavigationService.navigatereset("MessagesSell", {type: 2});
                            //NavigationService.navigateParams("MessagesSell", {type: 1});
                            break;
                        default:
                        // console.log("notificationOpen", notificationOpen.notification.data.type)

                    }

                }
                catch (e) {

                }
            }
        }*/

    componentWillUnmount() {
        if (Platform.OS !== "web") {
            this.notificationOpenedListener();
            //this.notificationOpenedListener();
            this.unsubscribeFromNotificationListener();
        }

    }

    async getData(page) {
        //  let {item, data} = this.props.route.params

        let after = "0000-00-00";
        //   this.props.callService(urlListOperatorFireApplyScreen, `?type=${this.props.typee}&Condition=`, TypeGetListOperatorFireApplyScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlListOperatorFireApplyScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetListOperatorFireApplyScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetListOperatorFireApplyScreen, _GET, page, 10)
  */

        let paramss = {
            "_operation": typeExport._Fire,

            "mode": typeExport._GetDashboard,
            "lang": i18n.locale,
            "_session": store.getState().reducerSplashGetAllData.token,
            "page": page,
            "device": global._Device ? global._Device.value : null,


        };
        if (store.getState().reducerSplashGetAllData.Connection) {

            this.props.callService(typeExport._baseUrl125, paramss, typeExport.TypeGetListOperatorFireApplyScreen, typeExport._POST, page, 10, null)

        } else {
            // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorFireApply + item.type)
            // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorFireApplyFilter + item.type)
            // store.dispatch(serviceActionListFilter(listFilter))
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))

            store.dispatch(serviceActionError('not connection', 1))
        }

    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };

    _onMapReady = () => this.setState({marginBottom: 0})


    async sendLocation(coordinate, battery) {
        //alert("خارج از محدوده   " + l)
        store.dispatch(serviceActionSetLocation({coords: coordinate}))


        //  console.log("uniqueId", uniqueId, battery)
        let formData = new FormData();
        formData.append('_operation', typeExport._Fire);
        formData.append('mode', "UpdateLocation");
        formData.append('lang', i18n.locale);
        formData.append('lat', coordinate.latitude);
        formData.append('lng', coordinate.longitude);
        formData.append('alt', coordinate.altitude);
        formData.append('speed', coordinate.speed);
        formData.append('accuracy', coordinate.accuracy);
        formData.append('time', coordinate.timestamp);
        formData.append('heading', coordinate.heading);
        formData.append('isFromMockProvider', coordinate.isFromMockProvider);

        formData.append('battry', battery);
        formData.append('imei', MAC_ADDRESS);
        formData.append('mac', MAC_ADDRESS);
        formData.append('bearing', null);
        formData.append('token_fb', this.props.DataSplashScreen.token_fb);
        formData.append('token', this.props.DataSplashScreen.token);
        formData.append('device', global._Device ? global._Device.value : null);


        axios.post(global.UrlWebService125, formData, {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                //  "Authorization": `Basic ${base64.encode(params.username + ':' + params.password)}`
            },
            timeout: typeExport._TIMEOUT,
        })
            .then(async response => {
            }).catch((e) => {

            console.log("error sendLocation", e);
        })
    }


    exitApp() {

        HMAlert(
            i18n.t('constant.message'),
            i18n.t('constant.WantToLogOut'),
            [
                // {text: 'Ask me later', onPress: () => {}},
                {
                    text: i18n.t('constant.No'), onPress: () => {


                    }, style: 'cancel'
                },
                {
                    text: i18n.t('constant.Yes'), onPress: () => {
                        container.requestServerExit()
                        //, NavigationService.resetTo('SplashScreen')
                    }
                },
            ],
            {cancelable: true}
        )


    }

    requestServerExit() {
        container.setState({
            isLoadingExit: true,
        })
        let formData = new FormData();
        formData.append('_operation', typeExport._Fire);
        formData.append('mode', "Signout");
        formData.append('lang', i18n.locale);
        formData.append('token_fb', container.props.DataSplashScreen.token_fb);
        formData.append('token', container.props.DataSplashScreen.token);
        formData.append('device', global._Device ? global._Device.value : null);


        axios.post(global.UrlWebService125, formData, {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                //  "Authorization": `Basic ${base64.encode(params.username + ':' + params.password)}`
            },
            timeout: typeExport._TIMEOUT,
        })
            .then(async response => {

                this.setState({
                    isLoadingExit: false,
                })
                if (response.data.success) {
                    AsyngStorageClass.removeToken();
                    //Tools.remove()
                    NavigationService.resetTo("LoginStackScreen")

                } else {
                    Alert.alert(i18n.t('constant.message'), i18n.t('constant.retry'), [
                            // {text: 'Ask me later', onPress: () => {}},
                            // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            {
                                text: i18n.t('constant.ok'), onPress: () => {
                                }
                            },
                        ],
                        {cancelable: true}
                    )
                }
            }).catch((e) => {
            console.log("error", e);

            container.setState({
                isLoadingExit: false,
            })
            Alert.alert(i18n.t('constant.message'), i18n.t('constant.retry'), [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        }
                    },
                ],
                {cancelable: true}
            )

        })
    }

    render() {
        // let {item, data} = this.props.route.params
        let myLocation = store.getState().reducerSplashGetAllData.Location;

        // let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar

        // let childFilter = result.items[this.state.indexFilter].list;
        //let childFilter = this.props.ListFilter && this.props.ListFilter.length > 0 ? this.props.ListFilter[this.state.indexFilter] : [];
        return (
            <View style={{position: 'relative', flex: 1,}}>


                <View style={{position: 'absolute', height: 1, width: 1}}>
                    <HMMap
                        ref={ref => (this.map = ref)}
                        //   provider={PROVIDER_GOOGLE} // remove if not using Google Maps
                        onMapReady={this._onMapReady}
                        style={{

                            width: "100%",
                            //height:height-moderateScale(200),
                            height: "100%", marginBottom: this.state.marginBottom
                        }}

                        showsUserLocation={true}
                        //          followsUserLocation={true}
                        showsMyLocationButton={true}

                        // onRegionChangeComplete={this.onRegionDidChange}
                        onRegionChangeComplete={(w) => {
                            /*   this.props.changeLatLong ? this.props.changeLatLong(w) : null
                               global._regionFeature = w;

                               this.getAddressOfPoint(w.latitude, w.longitude)
                               // this.setState({
                               //     addressMap: ''
                               // })*/
                        }}

                        onUserLocationChange={async (p) => {
                            // console.log(p.nativeEvent)

                            let coordinate = p.nativeEvent.coordinate
                            let battery = null;

                            await DeviceInfo.getBatteryLevel().then(batteryLevel => {
                                //   alert(batteryLevel.toFixed(2)*100)
                                battery = parseInt(batteryLevel.toFixed(2) * 100)
                                //battery = batteryLevel
                                // 0.759999
                            });

                            if (this.state.OnceSendBattery && battery <= 15) {
                                this.setState({
                                        OnceSendBattery: false,
                                        OnceSendLocation: false,

                                    },
                                    () => {

                                        this.sendLocation(coordinate, battery)
                                    }
                                )

                            }
                            else {
                                if (!myLocation || (this.state.OnceSendLocation)) {

                                    this.setState({
                                        OnceSendLocation: false
                                    })
                                    myLocation = {coords: coordinate}
                                    //store.dispatch(serviceActionSetLocation({coords: coordinate}))
                                    this.sendLocation(coordinate, battery)

                                }
                                else {
                                    let l = Tools.getDistance(coordinate, myLocation.coords)
                                    if (l > 20) {

                                        this.sendLocation(coordinate, battery)
                                    }
                                    //
                                    // this.setState({
                                    //     updateMyLocation:coordinate
                                    // })
                                }


                            }

                        }}
                        initialRegion={{
                            latitude: this.state.lat,
                            longitude: this.state.long,
                            latitudeDelta: 0.005,
                            longitudeDelta: 0.005,
                        }}
                    >
                    </HMMap>
                </View>

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBar
                            exit={true}
                            menu={true}
                            back={false}

                            props={this.props} statusBarTransparent
                            // text={i18n.t('ListOperatorFireApply.title')}
                            text={this.props.DataSplashScreen && this.props.DataSplashScreen.user ? (this.props.DataSplashScreen.user.name + " " + this.props.DataSplashScreen.user.family + " ( " + this.props.DataSplashScreen.user.unit + " ) ") : ""}
                            //text={(data.name ? data.name : (data.title ? data.title : ''))}
                            //  text={this.state.arraySelected.length}


                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                            funcExit={this.exitApp}
                        />

                        <View style={{flex: 1}}>

                            <TouchableOpacity
                                onPress={() => {
                                    NavigationService.navigateParams("ListMessageHistoryOperatorFireScreen")

                                }}
                                style={{
                                    width: '96%',
                                    height: moderateScale(33),
                                    backgroundColor: Colors.colorSecondPrimary,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    alignSelf: 'center',
                                    flexDirection: 'row',
                                    marginTop: moderateScale(4),
                                    marginHorizontal: moderateScale(4),
                                    borderRadius: moderateScale(8)
                                }}>


                                <HMTextView
                                    numberOfLines={1}
                                    type={"bold"}
                                    // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                    text={i18n.t('constant.MessageRecords')}
                                    style={{
                                        fontSize: moderateScale(12),
                                        color: Colors.white,
                                        marginHorizontal: moderateScale(4)
                                        //  marginTop: moderateScale(4),
                                        //  textAlign: "right",
                                    }}/>


                            </TouchableOpacity>

                            <EmptyView empty={this.props.empty}/>
                            <FlatList
                                data={this.props.results}
                                renderItem={this.renderItem}
                                keyExtractor={(item, index) => index.toString()}
                                ListEmptyComponent={() =>
                                    null}
                                //  ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                ListFooterComponent={this.renderFooter.bind(this)}
                                //refreshing={this.props.showRefresh}
                                refreshing={false}
                                onRefresh={this.handleRefresh.bind(this)}
                                onEndReached={this.handleLoadMore.bind(this)}
                                onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                            />
                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData(this.props.page)}/> : null
                            }
                            {
                                this.state.isLoadingExit ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }


                        </View>
{/*
                   <HMBottomSheetSwipeablePanel/>
*/}
                        {/*    <HMBottomSheetModal
                            ref={ref => {
                                this.refRBSheet = ref
                            }}
                            closeOnDragDown={false}
                            closeOnPressMask={false}
                            customStyles={{
                                wrapper: {
                                    backgroundColor: "transparent"
                                },
                                draggableIcon: {
                                    backgroundColor: "#000"
                                }
                            }}
                        >
                            <View style={{width: '100%', height: moderateScale(200), backgroundColor: "#ee0300"}}/>
                        </HMBottomSheetModal>*/}
                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    renderItem = ({item, index}) => {
        return <AdapterListOperatorFireApply item={item}
            //item_parent={this.props.route.params.item}
                                             index={index} hiddenModal={this.hiddenModal}/>;
    }

    checkSelect(item, index) {
        let l = container.state["selectFilter" + index];

        return l && l.id != 0
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.id !== 0
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.id !== 0
        //
        //     default:
        //
        // }
    }

    SelectNameFilter(item, index) {
        //let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar

        let l = this.state["selectFilter" + index]

        return l && l.value ? l.value : item.name
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.value
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.value
        //
        //     default:
        //
        // }
    }

    renderItemFilter = ({item, index}) => {
        let checkIndex = this.checkSelect(item, index);
        // let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar
        let idx = container.state.arraySelected.findIndex(obj => obj.index === index);

        return <View
            onPress={() => {

            }
            }
            style={{
                paddingHorizontal: moderateScale(3),
                backgroundColor: checkIndex ? Colors.colorPrimary : Colors.white,
                borderRadius: moderateScale(4),
                marginHorizontal: moderateScale(2)
            }}
        >
            <View style={[{
                //marginVertical: moderateScale(15),
                height: moderateScale(30),
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row'
            }]}>

                {
                    checkIndex ?

                        <View style={{flexDirection: 'row'}}>


                            <TouchableOpacity
                                onPress={() => {
                                    //  let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
                                    let arr = container.state.arraySelected;

                                    if (idx !== -1) {
                                        arr.splice(idx, 1)

                                        container.setState({
                                                arraySelected: arr,
                                                [`selectFilter${index}`]: {
                                                    value: item.name,
                                                    id: item.id,
                                                    type: item.type
                                                },
                                                visibleModal: '',
                                            },

                                            () => {
                                                container.getData(1)
                                            }
                                        )
                                    }
                                    // container.setState({
                                    //         [`selectFilter${index}`]: {
                                    //             value: item.name,
                                    //             id: item.id,
                                    //             type:item.type
                                    //         },
                                    //         visibleModal: '',
                                    //     },
                                    //     () => {
                                    //         let arr = this.state.arraySelected;
                                    //         this.setState({
                                    //                 arraySelected: arr
                                    //             },
                                    //             () => {
                                    //                 container.getData(1)
                                    //             }
                                    //         )
                                    //
                                    //     }
                                    // )

                                }}
                                style={{
                                    alignSelf: 'center',
                                    //  marginHorizontal:moderateScale(6)
                                }}>
                                <HMIcon name={"md-close"} style={{
                                    fontSize: moderateScale(20),
                                    color: '#f2f2f2'
                                }}/>

                            </TouchableOpacity>
                        </View>
                        :
                        null


                }
                {
                    checkIndex ?
                        <View style={{width: moderateScale(6),}}/>

                        :
                        null
                }
                <TouchableOpacity
                    onPress={() => {

                        this.setState({
                                indexFilter: index,
                                typeFilter: item.type,
                                ["dataSource" + index]: item.list
                            },
                            () => {
                                //  this.onShow(item.type == 2 ? 'Operational_Unit' : 'Condition')
                                this.onShow('Modal')

                            })
                    }
                    }

                    style={{alignItems: 'center', flexDirection: 'row'}}
                >

                    <HMTextView text={this.SelectNameFilter(item, index)} type={"bold"}
                                style={{
                                    color: checkIndex ? Colors.white : Colors.gray,
                                    //marginHorizontal: moderateScale(6),
                                    fontSize: moderateScale(11),
                                    textAlign: 'center',

                                }}/>
                    <HMIcon name={"ios-arrow-down"} style={{
                        fontSize: moderateScale(11),
                        color: checkIndex ? '#f2f2f2' : Colors.gray,
                        marginHorizontal: moderateScale(2),
                        marginTop: moderateScale(3)
                    }}/>
                </TouchableOpacity>


            </View>

        </View>
    }

    /*  renderItems = ({item, index}) => {
          return <DetailsAdapter
              item={item}
              index={index}
              navigation={this.props.navigation}
              props={this.props.route.params}/>;
      }*/
    handleRefresh = () => {
        if (!this.props.showRefresh)
            if (store.getState().reducerSplashGetAllData.Connection) {
                this.getData(1)
            } else {
                //   ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
            }


        //  this.props.callService(urlListOperatorFireApplyScreen, `?type=${this.props.typee}&city=`, TypeGetListOperatorFireApplyScreen, 'POST', 1)
    }

    renderFooter() {

        if (this.props.failed === false) {
            return (this.props.lazyload_end || this.props.page === 0) ? null :

                // this.props.showRefresh?null :

                <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>


        } else {
            return (
                <HMButton
                    text={i18n.t('constant.retry')}
                    style={stylesButton.buttonModalStyle}
                    onPress={() =>
                        this.getData(this.props.page)
                    }

                />

            );
        }
    }

    handleLoadMore() {
        if (this.props.results.length > 0 && this.props.lazyload_end !== true && this.props.showLoading !== true && store.getState().reducerSplashGetAllData.Connection) {
            // this.props.callService(urlListOperatorFireApplyScreen, `?type=${this.props.typee}&Condition=`, TypeGetListOperatorFireApplyScreen, 'POST', this.props.page)
            if (this.props.page === 0)
                this.getData(1)
            else
                this.getData(this.props.page)
        }
    }

    onChange(index, data) {

        let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
        let arr = container.state.arraySelected;

        if (idx !== -1) {
            arr.splice(idx, 1)

            container.setState({
                    arraySelected: arr
                },

                () => {
                    //  container.state.arraySelected.slice(container.state.indexFilter, 1)
                    container.state.arraySelected.push({
                        index: container.state.indexFilter,
                        data: data,
                        id: data.id,
                        value: data.name,
                        type: container.state.typeFilter
                    })
                }
            )

        } else {
            container.state.arraySelected.push({
                index: container.state.indexFilter,
                data: data,
                id: data.id,
                value: data.name,
                type: container.state.typeFilter
            })
            // arr = [...newState.listFilter, {...action.data}]
            // newState.listFilter = arr
        }

        let l = container.state.indexFilter

        container.setState({
                [`selectFilter${l}`]: {value: data.name, id: data.id, type: container.state.typeFilter},
                //indexFilterCondition: index,
                visibleModal: '',
            },
            () => {
                container.getData(1)
            }
        )
    }


    hiddenModal() {
        container.setState({
                visibleModal: ''
            },
            () => {
            })
    }

    onShow(data) {
        container.setState({
            visibleModal: data,

        });
    }

    SearchFilterFunction(data, name, text, childFilter) {
        // let dataSource = "dataSource" + data
        // const newData = this.state[data].filter(function (item) {
        //     const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
        //     const textData = text.toUpperCase()
        //     return itemData.indexOf(textData) > -1
        // })
        // this.setState({
        //         [dataSource]: newData,
        //         //dataSource: newData,
        //         [name]: text
        //     },
        //     () => {
        //     })
        //

        let dataSource = "dataSource" + this.state.indexFilter;
        name = name + this.state.indexFilter;
        const newData = childFilter.list.filter(function (item) {
            const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
            const textData = text.toUpperCase()
            return itemData.indexOf(textData) > -1
        })
        this.setState({
                [dataSource]: newData,
                //dataSource: newData,
                [name]: text
            },
            () => {
            })
    }

}
